import React, {Component} from "react";
import {Header, Segment} from "semantic-ui-react";
import { Link } from "react-router-dom";
import {Icon} from "../icon/icon";

import "./not-found.scss";

export class Notfound extends Component {
    render(): JSX.Element {
        return (
            <Segment className="not-found" placeholder>
                <Header icon>
                    <Icon name="holmes" />
                    404<br/>Seite nicht gefunden.
                </Header>
                <Segment.Inline>
                    <Link to="/">Karte anzeigen</Link>
                </Segment.Inline>
            </Segment>
        );
    }
}
